import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import TrackService from '../services/TrackService'
import DateUtils from '../utils/DateUtils';
import SearchComponent from './SearchComponent';
import { useAuth, errorHandling} from '../context/AuthContext';

export const SEARCHPARAM = "searchTerm"

const ListTrackComponent = (props) => {
    const [tracks, setTracks] = useState([]);
    const [searchterm, setSearchterm] = useState();
    const [initLoad, setInitLoad] = useState(true);
    const [tracksLoaded, setTraksLoaded] = useState(false);
    const navigate = useNavigate();

    const { user } = useAuth();
    const { setUser } = useAuth();

    const setSearchTermToStoreage = (term) =>{
        localStorage.setItem(SEARCHPARAM, term);        
        setSearchterm(term);
    }

    var querySearch = null;
    if(localStorage.getItem(SEARCHPARAM) != null){
        var querySearch = localStorage.getItem(SEARCHPARAM) 
        if(searchterm !== querySearch){
            setSearchterm(querySearch)  
        }
    }

    useEffect(()=>{
        setInitLoad(false)
        // no TracksLoaded by SearchTerm effect than call Load
        if(!tracksLoaded){
            loadTracks(searchterm);
        }
    },[])

    useEffect(() => {       
        if(!initLoad){    
            loadTracks(searchterm);
        }
    }, [searchterm]);


    const loadTracks = async (term) =>{
        await TrackService.searchTrack(user, term)
        .then((json) => {
            setTracks(json.data) 
            setTraksLoaded(true)
        })
        .catch((error)=>errorHandling(error, redirectToLogin));
    }

    const redirectToLogin = (response) =>{
        localStorage.setItem("user", null);
        setUser(null)
        navigate('/login/' +response.statusText)
    };

    return (
        <div>
                <h2 style={{marginTop:"20px"}} className="text-center">Liste der Tracks</h2>
                <SearchComponent searchTerm={searchterm} setSearchterm={setSearchTermToStoreage}/>
                {tracksLoaded && (tracks == null || tracks.length <= 0) &&
                    <div className="defaultMargin searchInfoMessage alert alert-danger alert-dismissible fade show">
                        Keine Tracks mit Suchanfrage  <strong>"{searchterm}"</strong> gefunden!
                    </div>
                }
                {(tracks != null && tracks.length > 0) &&
                   <div className="defaultMargin track-table">
                    <table className = "table table-striped table-bordered hover">
                        <thead>
                            <tr>
                                <th>Vorname</th>
                                <th>Nachname</th>
                                <th>Telefon</th>
                                <th>Zeitpunkt der letzten Übermittlung</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tracks.sort((a, b) => b.state.localeCompare(a.state)).map(
                                    track => 
                                    <tr onClick={ () => navigate(`/track/${track.id}`)} className={track.state === "RUNNING" ? 'table-success tableRowClick' : 'tableRowClick'} key = {track.id}>                                
                                            <td> {track.firstname} </td>   
                                            <td> {track.lastname}</td>
                                            <td> {track.phone} </td>
                                            <td> <DateUtils timestamp={track.lastTimestamp}/></td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    </div>
                }
        </div>
    )
}

export default ListTrackComponent